import { Controller, useFormContext } from 'react-hook-form';
import { format } from 'date-fns';
import type { CollaboratorAllocationFormValues } from './CollaboratorAllocationForm';

export interface NoticeReasonFieldProps {
  endDate: Date | null;
}

export function NoticeReasonField({ endDate }: NoticeReasonFieldProps) {
  const {
    control,
    formState: { errors },
  } = useFormContext<CollaboratorAllocationFormValues>();

  return (
    <div className="space-y-2">
      <label htmlFor="notice-reason" className="text-sm font-medium text-gray-700">
        Motivo do aviso prévio <span className="text-red-500">*</span>
      </label>
      <Controller
        name="noticeReason"
        control={control}
        render={({ field }) => (
          <textarea
            {...field}
            value={field.value ?? ''}
            id="notice-reason"
            rows={3}
            maxLength={500}
            placeholder="Ex.: pedido de demissão, término de contrato, acordo entre as partes"
            className="input-primary mt-1 w-full"
          />
        )}
      />
      {errors.noticeReason && (
        <p className="text-sm text-red-600">{errors.noticeReason.message}</p>
      )}
      <p className="text-sm text-gray-500">
        {endDate
          ? `No dia seguinte ao término (${format(endDate, 'dd/MM/yyyy')}), o colaborador será marcado como Desligado automaticamente, com este motivo.`
          : 'Informe a data de término. No dia seguinte a ela, o colaborador será marcado como Desligado automaticamente, com este motivo.'}
      </p>
    </div>
  );
}
